<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<div class="row m-0 col-md-12 p-0 formborder" style="align-items: flex-end; padding: 0.625rem 0.9375rem !important;">
  <div class="col-md-4 p-1 mt-2 mb-2">
    <form action="" class="search-text">
      <div class="bg-light rounded rounded-pill shadow-sm">
        <div class="input-group">
          <input
            type="text"
            id="FilterInputSearch"
            name="FilterInputSearch"
            (keyup)="applyFilter($event.target.value)"
            placeholder="What're you searching for?"
            class="form-control border-0 bg-light mt-2"
          />
          <div class="input-group-append">
            <button
              id="button-addon1"
              type="submit"
              class="btn btn-link text-primary"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="col-md-6">
          <div class="d-flex align-items-center" style="gap: 0.75rem; height: 2.125rem; margin-bottom: 0.75rem;">
            <button
      class="add-btn"
      style="float: right"
      (click)="openModal()"
    >
      <i class="fas fa-plus"></i> Add
    </button>
          </div>
        </div>
</div>
<div class="table-responsive mt-2">
  <mat-table [dataSource]="dataVariantSource">
    <ng-container matColumnDef="Id">
      <mat-header-cell
        class="grid-header"
        style="max-width: 3.125rem"
        *matHeaderCellDef
        >#</mat-header-cell
      >
      <!-- <mat-cell
        *matCellDef="let row; let i = index"
        class="grid-cell"
        style="max-width: 3.125rem; max-height: 0.3125rem"
        >{{ i + 1 }}</mat-cell
      > -->
      <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="max-width: 3.125rem">
        {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Manufacture">
      <mat-header-cell class="grid-header" *matHeaderCellDef>
        Manufacture
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Manufacture }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Vehicle_Variant_Name">
      <mat-header-cell class="grid-header" *matHeaderCellDef>
        Vehicle Variant Name
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Vehicle_Variant_Name }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Vehicle_Model_Name">
      <mat-header-cell class="grid-header" *matHeaderCellDef>
        Vehicle Model Name
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Vehicle_Model_Name }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Action">
      <mat-header-cell class="grid-header j-c-center" *matHeaderCellDef
        >Action</mat-header-cell
      >
      <mat-cell *matCellDef="let row" class="grid-cell j-c-center">
        <i
          class="fas fa-lg fa-edit margin-right-4xs cursor-style"
          aria-label="true"
          (click)="editVariantInfo(row)"
        ></i>
        <i
          class="fa fa-trash style-delete"
          (click)="removeVariantInfo(row)"
          aria-label="true"
        ></i>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedVariantColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedVariantColumns"></mat-row>
  </mat-table>
  <div class="row m-0 align-items-center">
    <div class="col-md-4">
      <button class="mt-3 btn font-size-12 button-btn" (click)="exportexcelNew()">
        <i
          class="fa fa-file-export mr-1"
          style="font-size: medium; cursor: pointer"
        ></i>
        Export
      </button>
    </div>
    <div class="col-md-8">
      <mat-paginator
        #paginatorRef
        [pageSizeOptions]="[20, 50]"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </div>
</div>


<!-- Export -->

<div class="row m-0 mt-3" [hidden]="!dataVariantSource">

  <table
    id="export_vehicle_varient"
    class="table table-bordered bg-white"
    style="font-family: 'Times New Roman', Times, serif; display: none"
  >
    <tr>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">
        Vehicle Variant Name
      </th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">
        Manufacture
      </th>
      <th style="background: var(--theme-primary) !important; border: 1px solid white">
        Vehicle Model Name
      </th>
    </tr>
    <tr *ngFor="let x of JsonData; let i = index">
      <td>{{ i + 1 }}</td>
      <td>{{x.Vehicle_Variant_Name}}</td>
      <td>{{ x.Manufacture }}</td>
      <td>{{x.Vehicle_Model_Name}}</td>
    </tr>
  </table>
  <!-- Model -->
  <div
    class="modal fade in"
    id="vehicleVarientMasterModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    data-backdrop="false"
    style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
  >
    <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header" style="padding: 0.625rem">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            VEHICLE VARIENT
          </h6>
          <button
            type="button"
            (click)="closeModal()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true"
              ><i class="far text-black fa-times-circle"></i
            ></span>
          </button>
        </div>
        <div class="modal-body" style="border: none">
          <div class="table-responsive">
            <form #f="ngForm" novalidate class="formborder">
              <div class="d-flex flex-column">
                <div class="col-md-12">
                  <span class="required-lable"> Manufacture Name </span>
                  <select
                    name="SelectManufacture"
                    id="SelectManufacture"
                    [(ngModel)]="SelectManufacture"
                    class="form-control input-text-css w-full"
                    #refSelectManufacture="ngModel"
                    (change)="LMS_GetVehicleModelMaster()"
                    required
                    [ngClass]="{
                      'is-invalid': f.submitted && refSelectManufacture.invalid,
                      'alert-warning':
                        refSelectManufacture.invalid &&
                        (refSelectManufacture.dirty ||
                          refSelectManufacture.touched ||
                          refSelectManufacture.untouched)
                    }"
                  >
                    <option value="">Select Manufacture Name</option>
                    <option
                      *ngFor="let data of ManufactureData"
                      [value]="data.Id"
                    >
                      {{ data.Manufacture }}
                    </option>
                  </select>
                </div>
                <div class="col-md-12">
                  <span class="required-lable"> Vehicle Model </span>
                  <select
                    name="SelectModel"
                    id="SelectModel"
                    [(ngModel)]="SelectModel"
                    class="form-control input-text-css w-full"
                    #refSelectModel="ngModel"
                    required
                    [ngClass]="{
                      'is-invalid': f.submitted && refSelectModel.invalid,
                      'alert-warning':
                        refSelectModel.invalid &&
                        (refSelectModel.dirty ||
                          refSelectModel.touched ||
                          refSelectModel.untouched)
                    }"
                  >
                    <option value="">Select Vehicle Model</option>
                    <option
                      *ngFor="let data of vehicleModelList"
                      [value]="data.Id"
                    >
                      {{ data.Model_Name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-12">
                  <span class="required-lable"> Vehicle Varient Name </span>
                  <input
                    type="text"
                    name="VehicleVariantName"
                    id="VehicleVariantName"
                    [(ngModel)]="VehicleVariantName"
                    placeholder="Variant Name"
                    class="form-control input-text-css w-full"
                    #refVehicleVariantName="ngModel"
                    required
                    [ngClass]="{
                      'is-invalid':
                        f.submitted && refVehicleVariantName.invalid,
                      'alert-warning':
                        refVehicleVariantName.invalid &&
                        (refVehicleVariantName.dirty ||
                          refVehicleVariantName.touched ||
                          refVehicleVariantName.untouched)
                    }"
                  />
                </div>
              </div>
              <div class="d-flex justify-content-end mr-3 mt-2">
                <button
                  type="button"
                  (click)="onSavevehicleVarientMaster()"
                  class="btn font-size-12 button-btn"
                  *ngIf="saveBtn"
                  [disabled]="!f.form.valid"
                  [class.spinner]="loading"
                >
                  Save
                </button>
                <button
                  type="button"
                  (click)="UpdateVarientInfo()"
                  *ngIf="updateBtn"
                  class="mt-3 btn font-size-12 button-btn"
                  [class.spinner]="loading"
                  [disabled]="!f.form.valid"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
